import { render, staticRenderFns } from "./OldNewWay.vue?vue&type=template&id=c560d2f4&"
import script from "./OldNewWay.vue?vue&type=script&lang=js&"
export * from "./OldNewWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c560d2f4', component.options)
    } else {
      api.reload('c560d2f4', component.options)
    }
    module.hot.accept("./OldNewWay.vue?vue&type=template&id=c560d2f4&", function () {
      api.rerender('c560d2f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/OldNewWay.vue"
export default component.exports